import React from 'react';
import styles from './PreviewLayout.module.scss';

interface PreviewLayoutProps {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  // Optional element above the card, e.g. a drawer "Back to …" link.
  lead?: React.ReactNode;
}

// Shared skeleton for the note / escalation / wiki previews, keeping the three
// visually identical (see the Owl Design System handoff).
const PreviewLayout: React.FC<PreviewLayoutProps> = ({
  children,
  sidebar,
  lead,
}) => (
  <div className={styles.canvas}>
    <div className={styles.scroll}>
      <div className={styles.body}>
        {lead && <div className={styles.lead}>{lead}</div>}
        <div className={styles.row}>
          <article className={styles.card}>{children}</article>
          {sidebar && <aside className={styles.aside}>{sidebar}</aside>}
        </div>
      </div>
    </div>
  </div>
);

interface SidebarCardProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

export const SidebarCard: React.FC<SidebarCardProps> = ({
  title,
  children,
}) => (
  <section className={styles.sidecard}>
    <div className={styles.sidecardHead}>{title}</div>
    {children}
  </section>
);

export default PreviewLayout;
